import TestimonialsMessage from "../common/testimonial-message";
import { optiVistaTestimonials } from "../../data/testimonials";


const TestimonialsOv = () => (
    <section id="testimonials" className="ov-bg-solid-teal-light">
        <div className="container-fluid py-5">
            <div className="row justify-content-center align-items-center">
                <div className="col-11">
                    <div className="row justify-content-center align-items-center pb-3">
                        <div className="col-md-10 text-center">
                            <h2 className="fw-bold">They’ve tried it and they are the proof that this works.</h2>
                        </div>
                    </div>
                    <TestimonialsMessage
                        testimonials={optiVistaTestimonials} />
                </div>
            </div>
        </div>
    </section>
)

export default TestimonialsOv;